import { memo } from 'react';

import { Props } from './types';

export const Star = memo(function Star({ className }: Props) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86 86" fill="none">
      <path
        d="M45.27 15.56L50.89 29.35Q52.4 33.06 56.39 33.35L71.25 34.44Q77.24 34.88 72.65 38.75L61.27 48.36Q58.22 50.94 59.17 54.83L62.73 69.3Q64.16 75.12 59.06 71.96L46.4 64.11Q43 62 39.6 64.11L26.94 71.96Q21.84 75.12 23.27 69.3L26.83 54.83Q27.78 50.94 24.73 48.36L13.35 38.75Q8.76 34.88 14.75 34.44L29.61 33.35Q33.6 33.06 35.11 29.35L40.73 15.56Q43 10 45.27 15.56Z"
        fill="#F7B733"
        stroke="#C97B0A"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path d="M43 20L48 34" stroke="#FFE08A" strokeWidth="3" strokeLinecap="round" opacity="0.8" />
    </svg>
  );
});

export const Wall = memo(function Wall({ className }: Props) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86 86" fill="none">
      <rect
        x="8"
        y="12"
        width="70"
        height="62"
        rx="5"
        fill="#7A5548"
        stroke="#4E342E"
        strokeWidth="3"
      />
      <g fill="#C96B4F">
        <rect x="11.5" y="15.5" width="20" height="11" rx="1.5" />
        <rect x="34.5" y="15.5" width="20" height="11" rx="1.5" />
        <rect x="57.5" y="15.5" width="17" height="11" rx="1.5" />

        <rect x="11.5" y="30.5" width="8.5" height="11" rx="1.5" />
        <rect x="23" y="30.5" width="20" height="11" rx="1.5" />
        <rect x="46" y="30.5" width="20" height="11" rx="1.5" />
        <rect x="69" y="30.5" width="5.5" height="11" rx="1.5" />

        <rect x="11.5" y="45.5" width="20" height="11" rx="1.5" />
        <rect x="34.5" y="45.5" width="20" height="11" rx="1.5" />
        <rect x="57.5" y="45.5" width="17" height="11" rx="1.5" />

        <rect x="11.5" y="60.5" width="8.5" height="11" rx="1.5" />
        <rect x="23" y="60.5" width="20" height="11" rx="1.5" />
        <rect x="46" y="60.5" width="20" height="11" rx="1.5" />
        <rect x="69" y="60.5" width="5.5" height="11" rx="1.5" />
      </g>
    </svg>
  );
});

export const Chest = memo(function Chest({ className }: Props) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86 86" fill="none">
      {/* Открытый сундук: между крышкой и бортом видна темная задняя стенка,
          внутри — стопки монет */}
      <path d="M18 27H68V46H18Z" fill="#4E342E" />
      <rect
        x="22"
        y="34.5"
        width="12"
        height="5"
        rx="2.5"
        fill="#F7B733"
        stroke="#C97B0A"
        strokeWidth="2"
      />
      <rect
        x="22"
        y="39.5"
        width="12"
        height="5"
        rx="2.5"
        fill="#F7B733"
        stroke="#C97B0A"
        strokeWidth="2"
      />
      <rect
        x="37"
        y="29.5"
        width="12"
        height="5"
        rx="2.5"
        fill="#F7B733"
        stroke="#C97B0A"
        strokeWidth="2"
      />
      <rect
        x="37"
        y="34.5"
        width="12"
        height="5"
        rx="2.5"
        fill="#F7B733"
        stroke="#C97B0A"
        strokeWidth="2"
      />
      <rect
        x="37"
        y="39.5"
        width="12"
        height="5"
        rx="2.5"
        fill="#F7B733"
        stroke="#C97B0A"
        strokeWidth="2"
      />
      <rect
        x="52"
        y="34.5"
        width="12"
        height="5"
        rx="2.5"
        fill="#F7B733"
        stroke="#C97B0A"
        strokeWidth="2"
      />
      <rect
        x="52"
        y="39.5"
        width="12"
        height="5"
        rx="2.5"
        fill="#F7B733"
        stroke="#C97B0A"
        strokeWidth="2"
      />
      <path
        d="M18 28V22C18 13.7 29 8 43 8C57 8 68 13.7 68 22V28H18Z"
        fill="#8D6E63"
        stroke="#4E342E"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path d="M31 10.5V26M55 10.5V26" stroke="#4E342E" strokeWidth="2.5" opacity="0.3" />
      <rect
        x="16"
        y="45"
        width="54"
        height="25"
        rx="3"
        fill="#A1887F"
        stroke="#4E342E"
        strokeWidth="3"
      />
      <rect
        x="37.5"
        y="49"
        width="11"
        height="12"
        rx="2.5"
        fill="#F7B733"
        stroke="#C97B0A"
        strokeWidth="2.5"
      />
      <circle cx="43" cy="54" r="1.8" fill="#C97B0A" />
    </svg>
  );
});

export const Tree = memo(function Tree({ className }: Props) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86 86" fill="none">
      <path
        d="M39 52H47V70H39Z"
        fill="#6D4C41"
        stroke="#4E342E"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M43 12L60 38H50L64 56H22L36 38H26Z"
        fill="#43A047"
        stroke="#2E7D32"
        strokeWidth="3"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export const Water = memo(function Water({ className }: Props) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86 86" fill="none">
      {/* Камыши на берегу большого пруда */}
      <path
        d="M22 38V29M29 38V23M36 38V27M43 38V22M50 38V27"
        stroke="#558B2F"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <rect x="20" y="19" width="4" height="9" rx="2" fill="#6D4C41" />
      <rect x="26.75" y="10" width="4.5" height="12" rx="2.25" fill="#6D4C41" />
      <rect x="33.75" y="16" width="4.5" height="10" rx="2.25" fill="#6D4C41" />
      <rect x="40.5" y="8" width="5" height="13" rx="2.5" fill="#6D4C41" />
      <rect x="48" y="17" width="4" height="9" rx="2" fill="#6D4C41" />

      {/* Большой пруд перетекает протокой в маленький */}
      <ellipse cx="37" cy="46" rx="30" ry="16" fill="#4FC3F7" stroke="#0288D1" strokeWidth="3" />
      <ellipse cx="65" cy="68" rx="11" ry="7.5" fill="#4FC3F7" stroke="#0288D1" strokeWidth="3" />

      <path
        d="M20 45C25 40 31 38.5 37 39"
        stroke="#E1F5FE"
        strokeWidth="3"
        strokeLinecap="round"
        opacity="0.9"
      />

      {/* Кувшинки */}
      <path
        d="M45 51L52.4 49.1A8 5 0 1 0 52.4 52.9Z"
        fill="#66BB6A"
        stroke="#388E3C"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <ellipse cx="37" cy="56.5" rx="3" ry="2" fill="#66BB6A" stroke="#388E3C" strokeWidth="1.5" />
      <ellipse
        cx="65"
        cy="66"
        rx="2.5"
        ry="1.7"
        fill="#66BB6A"
        stroke="#388E3C"
        strokeWidth="1.5"
      />
    </svg>
  );
});

export const Apple = memo(function Apple({ className }: Props) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86 86" fill="none">
      <path
        d="M43 30C30 22 14 30 14 48C14 62 26 76 34 76C38 76 40 74 43 74C46 74 48 76 52 76C60 76 72 62 72 48C72 30 56 22 43 30Z"
        fill="#E53935"
        stroke="#A01F1F"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path d="M43 30C43 22 46 16 50 12" stroke="#6D4C41" strokeWidth="4" strokeLinecap="round" />
      <path d="M45 22C50 12 62 12 66 16C60 24 50 26 45 22Z" fill="#43A047" />
      <ellipse
        cx="30"
        cy="46"
        rx="4"
        ry="8"
        fill="#FFFFFF"
        opacity="0.35"
        transform="rotate(-15 30 46)"
      />
    </svg>
  );
});
